import React from 'react';

import { Button, ButtonProps } from '@mui/material';

import useStyles from './styles';

const LauncherButton: React.ForwardRefRenderFunction<Element, ButtonProps> = ({ className, ...props }, ref) => {
    const { classes, cx } = useStyles();
    return (
        <Button
            ref={ref as never}
            variant="contained"
            disableElevation
            className={cx(classes.button, className)}
            {...props}
        />
    );
};

export default React.forwardRef(LauncherButton) as typeof Button;
